<ng-container *ngIf="props; else loading">

  <div class="card-info" (click)="handleClick(props)">

      <mat-icon (click)="close($event)" class="close-btn" alt="cerrar">close</mat-icon>

      <div class="container-message">
          <div class="card-icon">
            <sit-icon [icon]="props?.icon || Icon.alert_y" [sizeClass]="'icon-size-56'" class="d-flex"></sit-icon>
          </div>

          <div class="card-body">
            <h5>{{ props?.title }}</h5>
            <h2>{{ props?.statusValue }}</h2>
            <div class="footer-info">
              <div class="d-flex gap-8-px align-items-center">
                <sit-icon [icon]="Icon.calendar_y" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                <span>{{ props?.detectedDate | date:'dd/MM/yyyy - hh:mm' }}</span>
              </div>
              <div class="d-flex gap-8-px align-items-center">
                <sit-icon [icon]="Icon.location_y" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                <span>{{ props?.name }}</span>
              </div>
            </div>
          </div>
      </div>

  </div>


</ng-container>

<ng-template #loading>
  <sit-spinner />
</ng-template>
